<template>
  <head>
    <title>
      {{ $t("add") + " " + $t("to") + " " + $t("OurPartneres.title") }}
    </title>
  </head>
  <div class="add-our-partners">
    <AdminSidebar>
      <form class="form bg-dark my-5" @submit.prevent="addPartner()">
        <p class="title">
          {{ $t("add") + " " + $t("to") + " " + $t("OurPartneres.title") }}
        </p>

        <div class="flex">
          <label class="w-49">
            <input
              placeholder=""
              type="text"
              class="input"
              name="name_ar"
              v-model="data.name_ar"
            />
            <span
              :style="{
                left: $i18n.locale == 'ar' ? '' : '10px',
                right: $i18n.locale == 'ar' ? '10px' : '',
              }"
              >{{ $t("name_ar") }}</span
            >
          </label>
          <label class="w-49">
            <input
              placeholder=""
              type="text"
              class="input"
              name="name_en"
              v-model="data.name_en"
            />
            <span
              :style="{
                left: $i18n.locale == 'ar' ? '' : '10px',
                right: $i18n.locale == 'ar' ? '10px' : '',
              }"
              >{{ $t("name_en") }}</span
            >
          </label>
        </div>

        <div class="flex">
          <label class="w-49">
            <textarea
              placeholder=""
              class="input"
              name="description_ar"
              v-model="data.description_ar"
            ></textarea>
            <span
              :style="{
                left: $i18n.locale == 'ar' ? '' : '10px',
                right: $i18n.locale == 'ar' ? '10px' : '',
                top: '50px',
              }"
              >{{ $t("description_ar") }}</span
            >
          </label>
          <label class="w-49">
            <textarea
              placeholder=""
              class="input"
              name="description_en"
              v-model="data.description_en"
            ></textarea>
            <span
              :style="{
                left: $i18n.locale == 'ar' ? '' : '10px',
                right: $i18n.locale == 'ar' ? '10px' : '',
                top: '50px',
              }"
              >{{ $t("description_en") }}</span
            >
          </label>
        </div>

        <label>
          <input
            placeholder=""
            type="text"
            class="input"
            name="link"
            v-model="data.link"
          />
          <span
            :style="{
              left: $i18n.locale == 'ar' ? '' : '10px',
              right: $i18n.locale == 'ar' ? '10px' : '',
            }"
            >{{ $t("link") }}</span
          >
        </label>

        <div
          class="flex justify-content-center align-items-center"
          style="gap: 30px"
        >
          <!-- team image -->
          <label class="custum-file-upload" for="img">
            <div class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill=""
                viewBox="0 0 24 24"
              >
                <g stroke-width="0" id="SVGRepo_bgCarrier"></g>
                <g
                  stroke-linejoin="round"
                  stroke-linecap="round"
                  id="SVGRepo_tracerCarrier"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    fill=""
                    d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z"
                    clip-rule="evenodd"
                    fill-rule="evenodd"
                  ></path>
                </g>
              </svg>
            </div>
            <div class="text">
              <span>{{ files.image ? $t("uploaded") : $t("uploadimg") }}</span>
            </div>
            <input
              type="file"
              id="img"
              accept="image/*"
              @change="handleFileUpload($event, 'image')"
            />
          </label>
        </div>

        <div
          class="Error"
          :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'"
          style="text-align: start"
          v-if="ErrorMessage"
        >
          {{ ErrorMessage }}
        </div>
        <button class="submit">
          {{ $t("add") }}
        </button>
      </form>
    </AdminSidebar>
  </div>
</template>

<script>
import store from "@/store";
import axios from "axios";
import AdminSidebar from "@/components/AdminDashboard/AdminSidebar.vue";

export default {
  name: "add-our-partners",
  data() {
    return {
      data: {
        name_ar: "",
        name_en: "",
        description_ar: "",
        description_en: "",
        link: "",
      },
      ErrorMessage: "",
      files: {
        image: null,
      },
    };
  },
  methods: {
    handleFileUpload(e, key) {
      this.files[key] = e.target.files[0];
    },
    addPartner() {
      store.state.loading_state = 1;
      this.ErrorMessage = "";
      for (let key in this.data) {
        if (this.data[key] == "" && key != "link") {
          this.ErrorMessage =
            this.$i18n.locale === "ar"
              ? "الرجاء تعبئة كل الحقول المطلوبة"
              : "Please fill all the required fields";
          store.state.loading_state = 0;
          return;
        }
      }

      const form = new FormData();

      const image = document.querySelector("#img");
      const imageFiles = image.files;

      if (imageFiles.length > 0) {
        form.append(`img`, imageFiles[0]);
      } else {
        this.ErrorMessage =
          this.$i18n.locale === "ar"
            ? "الرجاء رفع صورة الشركة"
            : "Please upload company photo";
        store.state.loading_state = 0;
        return;
      }

      for (const [key, value] of Object.entries(this.data)) {
        form.append(key, value);
      }

      form.append("WEBSITE_ID", 1);

      const token = window.sessionStorage.getItem("token");
      axios
        .post(store.state.server + "api/add_partners", form, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          if (response.status == 200) {
            store.state.loading_state = 0;
            location.reload();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  components: {
    AdminSidebar,
  },
};
</script>
